angular
  .module('cfn')
  .factory('bookingAttachmentService', bookingAttachmentService);

bookingAttachmentService.$inject = ['$http'];

function bookingAttachmentService($http) {
  'use strict';

  let BASE_URL = '/365FarmNet/mod/booking-service/booking/attachment/rest/v1.0';

  function getListUrl(bookingId) {
    return BASE_URL + '/list/' + bookingId;
  }

  var getAttachmentUrl = function(attachmentId) {
    return BASE_URL + '/' + attachmentId;
  };

  var getAttachmentContent = function(attachmentId) {
    return $http.get(getAttachmentUrl(attachmentId)).then(function(response) {
      return response.data;
    });
  };

  var list = function(bookingId) {
    return $http.get(getListUrl(bookingId));
  };

  // Public
  return {
    /** returns the url to get the attachment (for embedding) */
    getAttachmentUrl: getAttachmentUrl,
    /**
     * return the content of the attachment.
     * Warning: makes only sense for text/json attachments!
     */
    getAttachmentContent: getAttachmentContent,
    /** Returns a list of all possible attachments */
    list: list
  };
}
